import { Vector } from "./Vector";
import { Time } from "./Time";
import { Earth } from "./Earth";
import * as Constants from "./Constants";

export class Moon {

    /** Equatorial radius of the Moon in km */
    static readonly RADIUS = 1738;

    /** Get rough unit vector of Moon in geocentric equatorial coordinates. Accuracy better than 1 arc minute. */
    static getRoughPos(tt: number): Vector {
        // First compute the time in Julian centuries since J2000
        let T = Time.getCenturiesSinceJ2000(tt);

        // Now compute mean elements of Moon's orbit
        let l0 = 0.606433 + 1336.855225 * T; // Mean longitude of moon (in revs.)
        let l = Constants.TWOPI * (0.374897 + 1325.55241 * T); // Mean anomaly of moon
        let ls = Constants.TWOPI * (0.993133 + 99.997361 * T); // Mean anomaly of sun
        let d = Constants.TWOPI * (0.827361 + 1236.853086 * T); // Long diff. moon/sun
        let f = Constants.TWOPI * (0.259086 + 1342.227825 * T); // Nodal separation
        let dl = 22640 * Math.sin(l) - 4586 * Math.sin(l - 2 * d) + 2370 * Math.sin(2 * d) + 769 * Math.sin(2 * l) - 668 * Math.sin(ls) - 412 * Math.sin(2 * f) - 212 * Math.sin(2 * l - 2 * d) - 206 * Math.sin(l + ls - 2 * d) + 192 * Math.sin(l + 2 * d) - 165 * Math.sin(ls - 2 * d) - 125 * Math.sin(d) - 110 * Math.sin(l + ls) + 148 * Math.sin(l - ls) - 55 * Math.sin(2 * f - 2 * d);
        let s = f + (dl + 412 * Math.sin(2 * f) + 541 * Math.sin(ls)) * Constants.ARCSECTORAD;
        let h = f - 2 * d;
        let n = -526 * Math.sin(h) + 44 * Math.sin(l + h) - 31 * Math.sin(-l + h) - 23 * Math.sin(ls + h) + 11 * Math.sin(-ls + h) - 25 * Math.sin(-2 * l + f) + 21 * Math.sin(-l + f);
        let sinpi = 3422.7 + 186.5398 * Math.cos(l) + 34.3117 * Math.cos(l - 2 * d) + 28.2333 * Math.cos(2 * d) + 10.1657 * Math.cos(2 * l);
        let r = Earth.RADIUS / (0.99953253 * sinpi * Constants.ARCSECTORAD);
        let l_moon = Constants.TWOPI * (l0 + dl / 1296000.0);
        let b_moon = (18520 * Math.sin(s) + n) * Constants.ARCSECTORAD;

        // Compute equatorial coordinates
        let cb = Math.cos(b_moon);
        let v = cb * Math.sin(l_moon);
        let w = Math.sin(b_moon);
        let coseps = Math.cos(Constants.OBLIQUITY_2000);
        let sineps = Math.sin(Constants.OBLIQUITY_2000);
        
        return new Vector(cb * Math.cos(l_moon) * r, (coseps * v - sineps * w) * r, (sineps * v + coseps * w) * r);
    }

}


// WEBPACK FOOTER //
// ./src/Moon.ts